import React from "react";
import { Typography } from "antd";
import colors from "../../constants/colors";

const { Title } = Typography;

export interface Props {
  title: string;
}

const TitleUnderlined: React.FC<Props> = ({ title }) => {
  return (
    <Title>
      <span
        style={{
          textDecoration: "underline",
          textDecorationColor: colors.secondary,
          fontSize: "1em",
        }}
      >
        {title}
      </span>
    </Title>
  );
};

export default TitleUnderlined;
